export default {
  user(state) {
    return state.authUser;
  }
};
